"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollPosition = void 0;
var react_1 = require("react");
var useScrollPosition = function (ref) {
    if (process.env.NODE_ENV === 'development') {
        if (typeof ref !== 'object' || typeof ref.current === 'undefined') {
            console.error('useScrollPosition expects a single ref argument');
        }
    }
    var _a = react_1.useState({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    }), state = _a[0], setState = _a[1];
    react_1.useEffect(function () {
        var el = ref.current;
        var handleScroll = function () {
            if (el) {
                var horizontalScrollbar = el.scrollWidth > el.clientWidth;
                var verticalScrollbar = el.scrollHeight > el.clientHeight;
                var bottom = el.scrollHeight - el.scrollTop - el.clientHeight;
                var right = el.scrollWidth - el.scrollLeft - el.clientWidth;
                setState({
                    top: verticalScrollbar ? el.scrollTop : false,
                    left: horizontalScrollbar ? el.scrollLeft : false,
                    bottom: verticalScrollbar ? bottom : false,
                    right: horizontalScrollbar ? right : false,
                });
            }
        };
        /** Handle scroll once rendered */
        requestAnimationFrame(handleScroll);
        el && on(el, 'scroll', handleScroll, { capture: false, passive: true });
        return function () { return el && off(el, 'scroll', handleScroll); };
    }, [ref]);
    return state;
};
exports.useScrollPosition = useScrollPosition;
/* https://github.com/streamich/react-use/blob/master/src/misc/util.ts */
function on(obj) {
    var _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    (_a = obj === null || obj === void 0 ? void 0 : obj.addEventListener) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([obj], args));
}
function off(obj) {
    var _a;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    (_a = obj === null || obj === void 0 ? void 0 : obj.removeEventListener) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([obj], args));
}
//# sourceMappingURL=useScrollPosition.js.map